import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import "./experts.css";
import expertData from "../data/SAP/expert_popup.json";

const Experts = () => {
  const [view, setView] = useState(false);
  const [viewMore, setViewMore] = useState(false);
  const [modalOpen, setModelOpen] = useState("");
  let records_arr = expertData[0].skillSets.map((item) => item);
  let records_arr1 = expertData[1].skillSets.map((item) => item);
  let records_arr2 = expertData[2].skillSets.map((item) => item);
  let records_arr3 = expertData[3].skillSets.map((item) => item);
  let records_arr4 = expertData[6].skillSets.map((item) => item);
  let records_arr5 = expertData[7].skillSets.map((item) => item);
  let records_arr6 = expertData[8].skillSets.map((item) => item);
  let records_arr7 = expertData[9].skillSets.map((item) => item);
  let records_arr8 = expertData[11].skillSets.map((item) => item);
  let records_arr9 = expertData[12].skillSets.map((item) => item);
  let records_arr10 = expertData[13].skillSets.map((item) => item);
  let records_arr11 = expertData[14].skillSets.map((item) => item);
  let records_arr12 = expertData[15].skillSets.map((item) => item);
  let records_arr13 = expertData[16].skillSets.map((item) => item);
  let records_arr14 = expertData[34].skillSets.map((item) => item);
  let records_arr15 = expertData[18].skillSets.map((item) => item);
  let records_arr16 = expertData[19].skillSets.map((item) => item);
  let records_arr17 = expertData[20].skillSets.map((item) => item);
  let records_arr18 = expertData[21].skillSets.map((item) => item);
  let records_arr19 = expertData[22].skillSets.map((item) => item);
  let records_arr20 = expertData[23].skillSets.map((item) => item);
  let records_arr21 = expertData[24].skillSets.map((item) => item);
  let records_arr22 = expertData[35].skillSets.map((item) => item);
  let records_arr23 = expertData[5].skillSets.map((item) => item);
  let records_arr24 = expertData[10].skillSets.map((item) => item);
  let records_arr25 = expertData[23].skillSets.map((item) => item);
  let records_arr26 = expertData[26].skillSets.map((item) => item);
  let records_arr27 = expertData[27].skillSets.map((item) => item);
  let records_arr28 = expertData[28].skillSets.map((item) => item);
  let records_arr29 = expertData[29].skillSets.map((item) => item);
  let records_arr30 = expertData[30].skillSets.map((item) => item);
  let records_arr31 = expertData[31].skillSets.map((item) => item);
  let records_arr32 = expertData[32].skillSets.map((item) => item);
  let records_arr33 = expertData[33].skillSets.map((item) => item);
  let records_arr34 = expertData[36].skillSets.map((item) => item);
  let records_arr35 = expertData[25].skillSets.map((item) => item);
  let certification_data = expertData[0].certificationAcquired.map(
    (item) => item
  );
  let certification_data1 = expertData[1].certificationAcquired.map(
    (item) => item
  );
  let certification_data2 = expertData[2].certificationAcquired.map(
    (item) => item
  );
  let certification_data3 = expertData[3].certificationAcquired.map(
    (item) => item
  );
  let certification_data4 = expertData[6].certificationAcquired.map(
    (item) => item
  );
  let certification_data5 = expertData[7].certificationAcquired.map(
    (item) => item
  );
  let certification_data6 = expertData[8].certificationAcquired.map(
    (item) => item
  );
  let certification_data7 = expertData[9].certificationAcquired.map(
    (item) => item
  );
  let certification_data8 = expertData[11].certificationAcquired.map(
    (item) => item
  );
  let certification_data9 = expertData[12].certificationAcquired.map(
    (item) => item
  );
  let certification_data10 = expertData[13].certificationAcquired.map(
    (item) => item
  );
  let certification_data11 = expertData[14].certificationAcquired.map(
    (item) => item
  );
  let certification_data12 = expertData[15].certificationAcquired.map(
    (item) => item
  );
  let certification_data13 = expertData[16].certificationAcquired.map(
    (item) => item
  );
  let certification_data14 = expertData[25].certificationAcquired.map(
    (item) => item
  );
  let certification_data15 = expertData[18].certificationAcquired.map(
    (item) => item
  );
  let certification_data16 = expertData[19].certificationAcquired.map(
    (item) => item
  );
  let certification_data17 = expertData[20].certificationAcquired.map(
    (item) => item
  );
  let certification_data18 = expertData[21].certificationAcquired.map(
    (item) => item
  );
  let certification_data19 = expertData[27].certificationAcquired.map(
    (item) => item
  );
  let certification_data20 = expertData[23].certificationAcquired.map(
    (item) => item
  );
  let certification_data21 = expertData[24].certificationAcquired.map(
    (item) => item
  );
  let certification_data22 = expertData[35].certificationAcquired.map(
    (item) => item
  );
  let certification_data23 = expertData[5].certificationAcquired.map(
    (item) => item
  );
  let certification_data24 = expertData[10].certificationAcquired.map(
    (item) => item
  );
  let certification_data25 = expertData[25].certificationAcquired.map(
    (item) => item
  );
  let certification_data26 = expertData[25].certificationAcquired.map(
    (item) => item
  );
  let certification_data27 = expertData[23].certificationAcquired.map(
    (item) => item
  );
  let certification_data28 = expertData[28].certificationAcquired.map(
    (item) => item
  );
  let certification_data29 = expertData[29].certificationAcquired.map(
    (item) => item
  );
  let certification_data30 = expertData[30].certificationAcquired.map(
    (item) => item
  );
  let certification_data31 = expertData[31].certificationAcquired.map(
    (item) => item
  );
  let certification_data32 = expertData[32].certificationAcquired.map(
    (item) => item
  );
  let certification_data33 = expertData[33].certificationAcquired.map(
    (item) => item
  );
  let certification_data34 = expertData[36].certificationAcquired.map(
    (item) => item
  );
  
  const expert_user1 = expertData.filter((item) => item.id === 1);
  const expert_user2 = expertData.filter((item) => item.id === 2);
  const expert_user3 = expertData.filter((item) => item.id === 3);
  const expert_user4 = expertData.filter((item) => item.id === 4);
  const expert_user5 = expertData.filter((item) => item.id === 7);
  const expert_user6 = expertData.filter((item) => item.id === 8);
  const expert_user7 = expertData.filter((item) => item.id === 9);
  const expert_user8 = expertData.filter((item) => item.id === 10);
  const expert_user9 = expertData.filter((item) => item.id === 12);
  const expert_user10 = expertData.filter((item) => item.id === 13);
  const expert_user11 = expertData.filter((item) => item.id === 14);
  const expert_user12 = expertData.filter((item) => item.id === 15);
  const expert_user13 = expertData.filter((item) => item.id === 16);
  const expert_user14 = expertData.filter((item) => item.id === 17);
  const expert_user15 = expertData.filter((item) => item.id === 35);
  const expert_user16 = expertData.filter((item) => item.id === 19);
  const expert_user17 = expertData.filter((item) => item.id === 20);
  const expert_user18 = expertData.filter((item) => item.id === 21);
  const expert_user19 = expertData.filter((item) => item.id === 22);
  const expert_user20 = expertData.filter((item) => item.id === 23);
  const expert_user21 = expertData.filter((item) => item.id === 24);
  const expert_user22 = expertData.filter((item) => item.id === 25);
  const expert_user23 = expertData.filter((item) => item.id === 36);
  const expert_user24 = expertData.filter((item) => item.id === 6);
  const expert_user25 = expertData.filter((item) => item.id === 11);
  const expert_user26 = expertData.filter((item) => item.id === 24);
  const expert_user27 = expertData.filter((item) => item.id === 27);
  const expert_user28 = expertData.filter((item) => item.id === 28);
  const expert_user29 = expertData.filter((item) => item.id === 29);
  const expert_user30 = expertData.filter((item) => item.id === 30);
  const expert_user31 = expertData.filter((item) => item.id === 31);
  const expert_user32 = expertData.filter((item) => item.id === 32);
  const expert_user33 = expertData.filter((item) => item.id === 33);
  const expert_user34 = expertData.filter((item) => item.id === 34);
  const expert_user35 = expertData.filter((item) => item.id === 37);
  const expert_user36 = expertData.filter((item) => item.id === 26);
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const botClickFun = () => {
    document.getElementById("cai-webclient-builtin-button").click();
  };
  const handleOpenModal = () => {
    setShow(true);
  };
  const handleCloseModal = () => {
    setShow(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setView(false);
    setViewMore(false);
  };

  // test commit 
  return (
    <>
      <div id="main_container">
        <div className="testimonial_banner1">
          <img src="/images/SAP/sap_experts.png" alt="Expert-Banner" />
        </div>
        <div className="section_container">
          <p className="infoPara">
            Meet the minds behind ATCI’s intensive, innovative, fit-for-market
            SAP learning programs, enabling Accenture to lead in the marketplace
            and deliver on the promise of client excellence.
          </p>
        </div>
        <div className="experts_container">
          <div className="topRowContent">
            <img
              src="/images/Experts/Updated/PraveenRajaram.png"
              alt="Expert"
              className="expert"
              onClick={() => {
                handleOpen();
                setModelOpen("modal-thirty-three");
              }}
            />
            <img
              src="/images/Experts/Updated/SaraswathiSwaminatham-new.png"
              alt="Expert"
              className="expert"
              onClick={() => {
                handleOpen();
                setModelOpen("modal-thirty-four");
              }}
            />
          </div>
          <div className="leadsRowContent">
            <img
              src="/images/Experts/Updated2/DhirenSinam.png"
              alt="Expert"
              className="expert"
              onClick={() => {
                handleOpen();
                setModelOpen("modal-five");
              }}
            />
            <img
              src="/images/Experts/Updated2/DineshPowale.png"
              alt="Expert"
              className="expert"
              onClick={() => {
                handleOpen();
                setModelOpen("modal-sixteen");
              }}
            />
            <img
              src="/images/Experts/Updated2/GauriDeshpande.png"
              alt="Expert"
              className="expert"
              onClick={() => {
                handleOpen();
                setModelOpen("modal-six");
              }}
            />
            <img
              src="/images/Experts/Updated2/JagdeeshaHulikal.png"
              alt="Expert"
              className="expert"
              onClick={() => {
                handleOpen();
                setModelOpen("modal-seventeen");
              }}
            />
            <img
              src="/images/Experts/Updated2/JaganathanThiyagarajan.png"
              alt="Expert"
              className="expert"
              onClick={() => {
                handleOpen();
                setModelOpen("modal-eleven");
              }}
            />
            <img
              src="/images/Experts/Updated2/RamapavaniPoruri.png"
              alt="Expert"
              className="expert"
              onClick={() => {
                handleOpen();
                setModelOpen("modal-two");
              }}
            />
            <img
              src="/images/Experts/Updated2/SateeshNalluri.png"
              alt="Expert"
              className="expert"
              onClick={() => {
                handleOpen();
                setModelOpen("modal-ten");
              }}
            />

            <img
              src="/images/Experts/Updated2/VaradharajanBalakrishnan.png"
              alt="Expert"
              className="expert"
              onClick={() => {
                handleOpen();
                setModelOpen("modal-four");
              }}
            />
          </div>
          <img
            src="/images/Experts/Updated2/AbdulShaik.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-twenty-four");
            }}
          />
          <img
            src="/images/Experts/Updated2/AdinarayanaTalla.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-eight");
            }}
          />
          <img
            src="/images/Experts/Updated2/AiswaryaMurali.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-thirteen");
            }}
          />
          <img
            src="/images/Experts/Updated2/AmitKumar.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-twenty-five");
            }}
          />
          <img
            src="/images/Experts/Updated2/AnjayChakravarty.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-fifteen");
            }}
          />
          <img
            src="/images/Experts/Updated2/ArnaKumari.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-nine");
            }}
          />
          <img
            src="/images/Experts/Updated2/Azharuddin.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-twenty-three");
            }}
          />
          {/* <img
            src="/images/Experts/Arnuna.png"
            alt="Expert"
            className="expert"
          /> */}
          <img
            src="/images/Experts/Updated2/BasappaHallur.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-twenty-two");
            }}
          />
          {/* <img
            src="/images/Experts/Updated/ChandraMouliPandey.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-fifteen");
            }}
          /> */}
          <img
            src="/images/Experts/Updated2/ChaudhurySourya.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-twenty-nine");
            }}
          />
          <img
            src="/images/Experts/Updated2/DevPawar.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-nineteen");
            }}
          />
          {/* <img
            src="/images/Experts/dhiren-sinam.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-five");
            }}
          /> */}
          {/* <img
            src="/images/Experts/Group 1732.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-sixteen");
            }}
          /> */}
          {/* <img
            src="/images/Experts/gauri-deshpande.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-six");
            }}
          /> */}

          {/* <img
            src="/images/Experts/Group 1733.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-seventeen");
            }}
          /> */}
          {/* <img
            src="/images/Experts/Group 1751.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-eleven");
            }}
          /> */}
          <img
            src="/images/Experts/Updated2/JhansiRaniJeganesh.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-thirty-two");
            }}
          />
          <img
            src="/images/Experts/Updated2/KarthikeyanMuthupandian.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-thirty-five");
            }}
          />
          {/* <img
            src="/images/Experts/Group 1743.png"
            alt="Expert"
            className="expert"
          /> */}
          <img
            src="/images/Experts/Updated2/KudrataliChowdhary.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-eighteen");
            }}
          />
          <img
            src="/images/Experts/Updated2/KumarSrinivasYadla.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-twenty");
            }}
          />
          <img
            src="/images/Experts/Updated2/LokeshManjunath.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-thirty");
            }}
          />
          <img
            src="/images/Experts/Updated2/MohamedAnas.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-forteen");
            }}
          />
          {/* <img
            src="/images/Experts/Group 1658.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-two");
            }}
          /> */}
          <Modal
            hideBackdrop
            open={open}
            onClose={handleClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className="expert_main-model"
          >
            <div className="model_experts">
              {modalOpen == "modal-two" &&
                expert_user2.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr1.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr1
                            .slice(8, records_arr1.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr1.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data1.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data1
                            .slice(6, certification_data1.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data1.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-one" &&
                expert_user1.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr
                            .slice(8, records_arr.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data
                            .slice(6, certification_data.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
                {modalOpen == "modal-thirty-six" &&
                expert_user36.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr35.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr35
                            .slice(8, records_arr35.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr35.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data14.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data14
                            .slice(6, certification_data14.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data14.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
                {modalOpen == "modal-thirty-five" &&
                expert_user35.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr34.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr34
                            .slice(8, records_arr34.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr34.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data34.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data34
                            .slice(6, certification_data34.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data34.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-three" &&
                expert_user3.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b>- {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr2.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr2
                            .slice(8, records_arr2.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr2.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data2.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data2
                            .slice(6, certification_data2.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data2.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-four" &&
                expert_user4.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr3.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr3
                            .slice(8, records_arr3.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr3.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data3.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data3
                            .slice(6, certification_data3.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data3.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-five" &&
                expert_user5.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr4.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr4
                            .slice(8, records_arr4.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr4.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data4.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data4
                            .slice(6, certification_data4.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data4.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-six" &&
                expert_user6.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr5.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr5
                            .slice(8, records_arr5.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr5.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data5.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data5
                            .slice(6, certification_data5.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data5.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-seven" &&
                expert_user7.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr6.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr6
                            .slice(8, records_arr6.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr6.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data6.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data6
                            .slice(6, certification_data6.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data6.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-eight" &&
                expert_user8.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr7.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr7
                            .slice(8, records_arr7.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr7.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data7.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data7
                            .slice(6, certification_data7.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data7.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-nine" &&
                expert_user9.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr8.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr8
                            .slice(8, records_arr8.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr8.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data8.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data8
                            .slice(6, certification_data8.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data8.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-ten" &&
                expert_user10.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr9.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr9
                            .slice(8, records_arr9.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr9.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data9.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data9
                            .slice(6, certification_data9.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data9.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-eleven" &&
                expert_user11.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr10.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr10
                            .slice(8, records_arr10.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr10.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data10.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data10
                            .slice(6, certification_data10.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data10.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-twelve" &&
                expert_user12.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr11.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr11
                            .slice(8, records_arr11.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr11.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data11.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data11
                            .slice(6, certification_data11.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data11.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-thirteen" &&
                expert_user13.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr12.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr12
                            .slice(8, records_arr12.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr12.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data12.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data12
                            .slice(6, certification_data12.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data12.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-forteen" &&
                expert_user14.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr13.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr13
                            .slice(8, records_arr13.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr13.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data13.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data13
                            .slice(6, certification_data13.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data13.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-fifteen" &&
                expert_user15.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr14.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr14
                            .slice(8, records_arr14.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr14.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      /> */}
                      
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-sixteen" &&
                expert_user16.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr15.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr15
                            .slice(8, records_arr15.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr15.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data15.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data15
                            .slice(6, certification_data15.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data15.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-seventeen" &&
                expert_user17.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr16.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr16
                            .slice(8, records_arr16.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr16.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data16.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data16
                            .slice(6, certification_data16.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data16.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-eighteen" &&
                expert_user18.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr17.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr17
                            .slice(8, records_arr17.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr17.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data17.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data17
                            .slice(6, certification_data17.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data17.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-nineteen" &&
                expert_user19.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr18.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr18
                            .slice(8, records_arr18.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr18.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data18.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data18
                            .slice(6, certification_data18.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data18.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-twenty" &&
                expert_user20.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b>- {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr19.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr19
                            .slice(8, records_arr19.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr19.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-twenty-one" &&
                expert_user21.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr19.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr20
                            .slice(8, records_arr20.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr20.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data20.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data20
                            .slice(6, certification_data20.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data20.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-twenty-two" &&
                expert_user22.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr21.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr21
                            .slice(8, records_arr21.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr21.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-twenty-three" &&
                expert_user23.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr22.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr22
                            .slice(8, records_arr22.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr22.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      /> */}
                      
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-twenty-four" &&
                expert_user24.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr23.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr23
                            .slice(8, records_arr23.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr23.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data23.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data23
                            .slice(6, certification_data23.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data23.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-twenty-five" &&
                expert_user25.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr24.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr24
                            .slice(8, records_arr24.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr24.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-twenty-six" &&
                expert_user26.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr25.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr25
                            .slice(8, records_arr25.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr25.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data27.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data27
                            .slice(6, certification_data27.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data27.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                    </div>
                  );
                })}
              {modalOpen == "modal-twenty-seven" &&
                expert_user27.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr26.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              {modalOpen == "modal-twenty-eight" &&
                expert_user28.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr27.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr27
                            .slice(8, records_arr27.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr27.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                       <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data19.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data19
                            .slice(6, certification_data19.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data19.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                    </div>
                  );
                })}
              {modalOpen == "modal-twenty-nine" &&
                expert_user29.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr28.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr28
                            .slice(8, records_arr28.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr28.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data28.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data28
                            .slice(6, certification_data28.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data28.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-thirty" &&
                expert_user30.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr29.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr29
                            .slice(8, records_arr29.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr29.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data29.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data29
                            .slice(6, certification_data29.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data29.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-thirty-one" &&
                expert_user31.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr30.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr30
                            .slice(8, records_arr30.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr30.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data30.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data30
                            .slice(6, certification_data30.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data30.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-thirty-two" &&
                expert_user32.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr31.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr31
                            .slice(8, records_arr31.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr31.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data31.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data31
                            .slice(6, certification_data31.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data31.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-thirty-three" &&
                expert_user33.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr32.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr32
                            .slice(8, records_arr32.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr32.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data32.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data32
                            .slice(6, certification_data32.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data32.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
              {modalOpen == "modal-thirty-four" &&
                expert_user34.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="model_heading_experts">
                        <p className="model-name">{item.name}</p>
                        <p className="model-name1">
                          <b>Email Id</b> - {item.EID}
                        </p>
                        <p className="model-name1">
                          {/* <b>Role</b> - {item.role} */}
                        </p>
                        <span
                          className="experts_close_btn_model"
                          onClick={handleClose}
                        >
                          <img
                            src="/images/Experts/close_img.png"
                            alt="icon"
                            className="experts_close_img"
                          />
                        </span>
                      </div>
                      <img
                        src="/images/Experts/top line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Skill sets.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Skill sets</p>
                      </div>

                      <div className="skill_sets_data">
                        {records_arr33.slice(0, 8).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text">{item}</p>
                            </div>
                          );
                        })}
                        {view &&
                          records_arr33
                            .slice(8, records_arr33.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {8 < records_arr33.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setView(!view)}
                        >
                          {view ? "View less" : "View more"}
                        </div>
                      )}
                      <img
                        src="/images/Experts/Middle line.png"
                        alt="Experts-img"
                        className="topline-img"
                      />
                      <div className="header_experts">
                        <img
                          src="/images/Experts/Certification Acquired.png"
                          alt="icon"
                          className="skill_set_img"
                        />
                        <p className="para_experts">Certification Acquired</p>
                      </div>
                      <div className="skill_sets_data">
                        {certification_data33.slice(0, 6).map((item) => {
                          return (
                            <div className="skill_sets_content">
                              <img
                                src="/images/Experts/Bulletpoint.png"
                                alt="icon"
                                className="skill_bullet_point_img"
                              />
                              <p className="skill_bullet_point_text1">{item}</p>
                            </div>
                          );
                        })}
                        {viewMore &&
                          certification_data33
                            .slice(6, certification_data33.length)
                            .map((item) => {
                              return (
                                <div className="skill_sets_content">
                                  <img
                                    src="/images/Experts/Bulletpoint.png"
                                    alt="icon"
                                    className="skill_bullet_point_img"
                                  />
                                  <p className="skill_bullet_point_text1">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                      </div>
                      {6 < certification_data33.length && (
                        <div
                          className="expert_viewmore_sp"
                          onClick={() => setViewMore(!viewMore)}
                        >
                          {viewMore ? "View less" : "View more"}
                        </div>
                      )}
                      {/* <img
                        src="/images/Experts/bottom line.png"
                        alt="Experts-img"
                        className="bottomline-img"
                      /> */}
                    </div>
                  );
                })}
            </div>
          </Modal>
          <img
            src="/images/Experts/Updated2/PrakashArumugam.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-thirty-six");
            }}
          />
          <img
            src="/images/Experts/Updated2/RamShekhar.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-thirty-one");
            }}
          />
          <img
            src="/images/Experts/Updated2/SachinChandrashekhar.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-twenty-six");
            }}
          />
          {/* <img
            src="/images/Experts/Group 1736.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-ten");
            }}
          /> */}
          <img
            src="/images/Experts/Updated2/ShyamBahadurSingh.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-one");
            }}
          />

          {/* <img
            src="/images/Experts/Group 1730.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-four");
            }}
          /> */}
          {/* <img
            src="/images/Experts/Updated/SoumyadiptaDas.png"
            alt="Expert"
            className="expert"
          /> */}
          <img
            src="/images/Experts/Updated2/SudheerKumar.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-twenty-seven");
            }}
          />
          <img
            src="/images/Experts/Updated2/SumitKumar.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-twenty-eight");
            }}
          />
          <img
            src="/images/Experts/Updated2/SusmitaPanigrahi.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-three");
            }}
          />
          <img
            src="/images/Experts/Updated2/VikramSeahwag.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-twelve");
            }}
          />
          {/* <img
            src="/images/Experts/Group 1742.png"
            alt="Expert"
            className="expert"
          /> */}
          <img
            src="/images/Experts/Updated2/VinithaRaj.png"
            alt="Expert"
            className="expert"
            onClick={() => {
              handleOpen();
              setModelOpen("modal-seven");
            }}
          />
        </div>
        <div className="socialMediaWrap">
          <button className="iconBtn icon6">
            <a
              href="https://atci.lkm.eitacademy.accenture.com/SAPAcademy/sap-calendar/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={process.env.PUBLIC_URL + "/images/SAP/sap_calendar.png"}
                alt="oracle-icon"
              />
              <span>SAP Calendar</span>
            </a>
          </button>
          <button className="iconBtn icon5">
            <a
              href="https://atci.lkm.accenture.com/LKM-eCatalog/SAP-Flipbook"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={process.env.PUBLIC_URL + "/images/SAP/catalogue_icon.png"}
                alt="ecatalogs-icon"
              />
              <span>SAP eCatalog</span>
            </a>
          </button>
          <button className="iconBtn icon4" onClick={botClickFun}>
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/SocialLearning/noun-chatbot-4562760.svg"
              }
              alt="oracle-icon"
            />
            <span>SAP Bot</span>
          </button>
          <button onClick={handleOpenModal} className="iconBtn icon1">
            <img
              src={
                process.env.PUBLIC_URL + "/images/SocialLearning/present.svg"
              }
              alt="oracle-icon"
            />
            <span>Request for Training</span>
          </button>
          <Modal
            open={show}
            onClose={handleCloseModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
          >
            <div className="model-container">
              <span
                className="close_btn_model_reqtraining"
                onClick={handleCloseModal}
              >
                X
              </span>
              <h4>Request For Training</h4>
              <div className="model_heading_reqtraining">
                <p className="model_name_reqtraining">
                  <a
                    href="https://lkmportal.atci.accenture.com/LMS/Need/RaiseTrainingRequest"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Link to raise training request
                  </a>
                </p>
                <div className="modal_content_reqtraining">
                  For further queries please get in touch with <br />
                </div>
                <p className="model_contact_reqtraining">
                  <a
                    href="mailto:s.saraswathi@accenture.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Swaminathan, Saraswathi.
                  </a>
                </p>
              </div>
            </div>
          </Modal>
          <button className="iconBtn icon2">
            <a
              href="https://web.yammer.com/main/org/accenture.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiI1NzgyMjY5OTUyMCJ9"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={
                  process.env.PUBLIC_URL + "/images/SocialLearning/Yammer1.png"
                }
                alt="oracle-icon"
              />
              <span>Connect with Community</span>
            </a>
          </button>
          <button className="iconBtn icon3">
            <a
              href="mailto:ATCI_LKM_SAP@accenture.com"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={process.env.PUBLIC_URL + "/images/SocialLearning/mail.svg"}
                alt="oracle-icon"
              />
              <span>Contact Us</span>
            </a>
          </button>
        </div>
      </div>
    </>
  );
};

export default Experts;
